import {Skeleton} from '@/shared/ui/components/skeleton';
import {ChatPanelFooter} from './chat-panel';

/** Mirrors `AssistantPage`: the chat header row, the transcript column, and the composer. */
export const AssistantSkeleton = () => (
  <div className="flex h-full min-h-0 flex-col" aria-busy="true">
    <div className="flex h-10 shrink-0 items-center gap-1 border-b px-4 lg:px-6">
      <Skeleton className="h-4 w-40" />
      <div className="ml-auto flex gap-1">
        <Skeleton className="size-8" />
        <Skeleton className="size-8" />
      </div>
    </div>
    <div className="mx-auto flex min-h-0 w-full max-w-3xl flex-1 flex-col justify-end gap-6 px-4 py-6">
      <Skeleton className="h-10 w-1/2 self-end rounded-3xl" />
      <Skeleton className="h-16 w-2/3" />
      <Skeleton className="h-10 w-2/5 self-end rounded-3xl" />
    </div>
    <ChatPanelFooter>
      <Skeleton className="h-28 w-full rounded-2xl" />
    </ChatPanelFooter>
  </div>
);
